<template>
  <section id="namestack">
      <ul class="roster" v-if="roster.length">
        <li class="name" v-for="person in roster" :key="person.id" :ref="person.id" :class="{ selected : selected == person.id}">{{person.name}}</li>
      </ul>
  </section>
</template>

<script>
export default {
  name: 'Namestack',
  data(){
    return {
      toBeExcluded: null,
      selected: null
    }
  },
  props: {
    roster: Array
  },
  methods: { 
    async trigger(){

      await this.$store.commit('excludeName', this.toBeExcluded);
            
      if(this.roster.length){
        
        let randomIndex = Math.floor(Math.random()*this.roster.length);
        let randomPerson = await this.roster[randomIndex];

        this.selected = randomPerson.id;
        this.toBeExcluded = await this.selected;

        await this.$store.commit('updatePicked', randomPerson);
      
      } else {
        this.toBeExcluded = null // reset excluder
      }
    }
  }
}
</script>

<style lang="scss">
@import './../../scss/variables';

#namestack {
  height: 100vh;
  width: 100vw;
  @include center;
  flex-direction: column;
  padding: 1rem;
  overflow: hidden;
  position: relative;
  z-index: 999;

  .roster {
    padding: 0;
    width: 100%;
    max-width: 50rem;
    margin: 4rem;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap:.75rem 1rem;

    .name {
      transition: all .5s ease;
      opacity: 1;
      font-size: 1.4rem;

      &.selected {
        color: white;
      }
    }
  }
}
</style>